// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh4[data-v-6e475a32] {\n\ttext-align: left;\n}\n.flex-row[data-v-6e475a32] {\n\tdisplay: flex;\n}\nlabel.button[data-v-6e475a32] {\n\tdisplay: inline-block;\n\ttext-align: center;\n\tflex-grow: 1;\n}\ninput[type='radio'][data-v-6e475a32] {\n\tdisplay: none;\n}\ninput[type='radio'][disabled] + label[data-v-6e475a32] {\n\tcursor: default;\n\topacity: 0.5;\n}\n", ""]);
// Exports
module.exports = exports;
